export const role='';
// export const serverUrl= "http://localhost:8081/api/v1";
// export const serverUrl= "https://bpis.us/liugh-web/";
export const serverUrl= "https://bpisglobal.com/liugh-web/";
// export const url = "/";
// export const serverUrl= "http://47.89.40.179:8081/liugh-web/";
// export const url = "/vue-admin";
export const url = "/";
export const defaultPageSize =50;

export const conditions= ["New","Refurbished","Used like new","Used very good","Used good","Used acceptable","Collectible like new","Collectible very good","Collectible good","Collectible acceptable"];


// WEBPACK FOOTER //
// ./src/globalVar.js